import React from 'react'
import { NavDropdown } from 'react-bootstrap'
import { useLocation } from 'react-router'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import AppbarDropdown from './appbar-dropdown'
import { getActiveSubRouteClass } from './helpers/helpers'
import { DIGEST_ROUTE, ResourcesProps, useResourcesItems } from './resources'
import { AETHER_ROUTE, useEnterpriseItems } from './enterprise'
import { useTourItems } from './custom-buttons'

// On medium screens the full menu does not fit next to the logo, so Resources,
// Enterprise and the tours collapse into this one dropdown, one section each.
// Large screens and the mobile menu keep the separate dropdowns.
const More = (props: ResourcesProps): JSX.Element | null => {
  const { _t } = useTypedTranslation()
  const currentRoute = useLocation().pathname.substring(1)
  const resourcesItems = useResourcesItems(props)
  const enterpriseItems = useEnterpriseItems()
  const tourItems = useTourItems()

  const sections = [
    { titleKey: 'resources', items: resourcesItems },
    { titleKey: 'enterprise', items: enterpriseItems },
    { titleKey: 'tours', items: tourItems },
  ].filter((section) => section.items.length > 0)

  if (sections.length === 0) {
    return null
  }

  return (
    <AppbarDropdown
      className={`appbar-show-medium ${getActiveSubRouteClass(
        [DIGEST_ROUTE, AETHER_ROUTE],
        currentRoute,
        'appbar-dropdown-selected'
      )}`}
      title={_t('more')}
    >
      {sections.map(({ titleKey, items }, index) => (
        <React.Fragment key={titleKey}>
          {index > 0 ? <NavDropdown.Divider /> : null}
          <NavDropdown.Header className="appbar-dropdown-section-header">{_t(titleKey)}</NavDropdown.Header>
          {items}
        </React.Fragment>
      ))}
    </AppbarDropdown>
  )
}

export default More
